import React, { useMemo } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useSelector } from 'react-redux';

export default function ProtectedServiceField({
  value,
  onChange,
  disabled = false,
  error = false,
  required = false,
  label = 'Service',
  label_id = 'guardrail-service-label',
}) {
  const project_services = useSelector((state) => state.projectServices || []);

  const https_enabled_services = useMemo(
    () =>
      project_services.filter(
        (service) =>
          service.enabled &&
          (service.type || '').toLowerCase() === 'https',
      ),
    [project_services],
  );

  return (
    <FormControl fullWidth required={required} error={error} disabled={disabled}>
      <InputLabel id={label_id}>{label}</InputLabel>
      <Select
        labelId={label_id}
        value={value || ''}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        {https_enabled_services.map((service) => {
          const service_id = service.id || service.service_id;
          return (
            <MenuItem key={service_id} value={service_id}>
              {service.name} - {service_id}
            </MenuItem>
          );
        })}
      </Select>
      {error ? (
        <FormHelperText>Service is required</FormHelperText>
      ) : null}
    </FormControl>
  );
}
